import { useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { openPreviewModal } from 'web-interactives-dashboard-ui/actions/ModalActions';
import { jsx as _jsx } from "react/jsx-runtime";
const PreviewMenuAction = ({
  interactiveId,
  containerType
}) => {
  const dispatch = useDispatch();
  const onClick = () => {
    dispatch(openPreviewModal({
      interactiveId,
      containerType
    }));
  };
  return /*#__PURE__*/_jsx(Button, {
    onClick: onClick,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "actionMenu.preview"
    })
  });
};
export default PreviewMenuAction;